import { motion } from "framer-motion";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
export const ProcessStepsCards = () => {
  return <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }}>
        <Card className="bg-white hover:shadow-md transition-shadow">
          <CardHeader>
            <CardTitle className="text-blue-700">1. Täytä hakemus</CardTitle>
            <CardDescription>Vie vain muutaman minuutin</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-gray-700">
              Täytä verkkolomakkeemme, jossa kysymme tarvittavat tiedot lainatarjouksen tekemistä varten. 
              Tietosi käsitellään turvallisesti ja luottamuksellisesti.
            </p>
          </CardContent>
        </Card>
      </motion.div>
      
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }}>
        <Card className="bg-white hover:shadow-md transition-shadow">
          <CardHeader>
            <CardTitle className="text-blue-700">2. Vertaile mahdollisia tarjouksia</CardTitle>
            <CardDescription>Saat useita tarjouksia</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-gray-700">Yleensä saat tarjoukset useilta pankeilta ja rahoituslaitoksilta. Voit helposti vertailla niiden korkoja, kuluja ja ehtoja ja valita itsellesi sopivimman.</p>
          </CardContent>
        </Card>
      </motion.div>
      
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }}>
        <Card className="bg-white hover:shadow-md transition-shadow">
          <CardHeader>
            <CardTitle className="text-blue-700">3. Tee sopimus pankin kanssa</CardTitle>
            <CardDescription>Hyväksy paras tarjous</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-gray-700">Kun olet valinnut parhaan tarjouksen, voit tehdä sopimuksen suoraan pankin kanssa. Rahat maksetaan tilillesi nopeasti sopimuksen teon jälkeen.</p>
          </CardContent>
        </Card>
      </motion.div>
    </div>;
};